import { AdvisoryAgainstData } from "./AdvisoryAgainstForm.schema";

/**
 * Flatten AdvisoryAgainstData into the PDF AcroForm field names
 * expected by docReject.pdf. Booleans are converted to "X" / "" so the
 * checkboxes render correctly in the PDF.
 */
export function flattenAdvisoryAgainst(
  data: AdvisoryAgainstData
): Record<string, unknown> {
  return {
    docRejectReason1: data.docRejectReason1 ? "X" : "",
    docRejectReason2: data.docRejectReason2 ? "X" : "",
    docRejectDet: data.docRejectDet ?? "",
  };
}
